import { barWrapper, barWrapperBackground, complete, data, footnote, header, headerLarge, headerExtraLarge, headerInline, headerInlineLarge, informational, inline, progressBar, step, stepProgress, warning, segmentBarWrapper, segmentWrapper, segmentBlock, segmentPointer, segmentLabel, segmentLegendWrapper, segmentLegendTitle, segmentLegendLabel, trendLargeWrapper, trendSmallWrapper, trendLarge, trendSmall, trendHeaderWrapper, } from '../styles/legacy';
import { barWrapper as barWrapperCitron, barWrapperBackground as barWrapperBackgroundCitron, complete as completeCitron, data as dataCitron, footnote as footnoteCitron, header as headerCitron, headerLarge as headerLargeCitron, headerExtraLarge as headerExtraLargeCitron, headerInline as headerInlineCitron, headerInlineLarge as headerInlineLargeCitron, informational as informationalCitron, inline as inlineCitron, progressBar as progressBarCitron, step as stepCitron, stepProgress as stepProgressCitron, warning as warningCitron, segmentBarWrapper as segmentBarWrapperCitron, segmentWrapper as segmentWrapperCitron, segmentBlock as segmentBlockCitron, segmentPointer as segmentPointerCitron, segmentLabel as segmentLabelCitron, segmentLegendWrapper as segmentLegendWrapperCitron, segmentLegendTitle as segmentLegendTitleCitron, segmentLegendLabel as segmentLegendLabelCitron, trendLargeWrapper as trendLargeWrapperCitron, trendSmallWrapper as trendSmallWrapperCitron, trendLarge as trendLargeCitron, trendSmall as trendSmallCitron, trendHeaderWrapper as trendHeaderWrapperCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var ProgressBar = citrusStyled.div('progressBar', { legacy: progressBar, citrus2022: progressBarCitron });
export var Inline = citrusStyled.div('inline', { legacy: inline, citrus2022: inlineCitron });
export var BarWrapper = citrusStyled.div('barWrapper', { legacy: barWrapper, citrus2022: barWrapperCitron });
export var BarWrapperBackground = citrusStyled.div('barWrapperBackground', {
    legacy: barWrapperBackground,
    citrus2022: barWrapperBackgroundCitron,
});
export var Footnote = citrusStyled.div('footnote', { legacy: footnote, citrus2022: footnoteCitron });
export var Header = citrusStyled.div('header', { legacy: header, citrus2022: headerCitron });
export var HeaderLarge = citrusStyled.div('headerLarge', { legacy: headerLarge, citrus2022: headerLargeCitron });
export var HeaderExtraLarge = citrusStyled.div('headerExtraLarge', {
    legacy: headerExtraLarge,
    citrus2022: headerExtraLargeCitron,
});
export var HeaderInline = citrusStyled.div('headerInline', {
    legacy: headerInline,
    citrus2022: headerInlineCitron,
});
export var HeaderInlineLarge = citrusStyled.div('headerInlineLarge', {
    legacy: headerInlineLarge,
    citrus2022: headerInlineLargeCitron,
});
export var InformationalBar = citrusStyled.div('informational', {
    legacy: informational,
    citrus2022: informationalCitron,
});
export var WarningBar = citrusStyled.div('warning', { legacy: warning, citrus2022: warningCitron });
export var CompleteBar = citrusStyled.div('complete', { legacy: complete, citrus2022: completeCitron });
export var DataBar = citrusStyled.div('data', { legacy: data, citrus2022: dataCitron });
export var Step = citrusStyled.div('step', { legacy: step, citrus2022: stepCitron });
export var StepProgressBar = citrusStyled.div('stepProgress', {
    legacy: stepProgress,
    citrus2022: stepProgressCitron,
});
export var SegmentBarWrapper = citrusStyled.div('segmentBarWrapper', {
    legacy: segmentBarWrapper,
    citrus2022: segmentBarWrapperCitron,
});
export var SegmentWrapper = citrusStyled.div('segmentWrapper', {
    legacy: segmentWrapper,
    citrus2022: segmentWrapperCitron,
});
export var SegmentBlock = citrusStyled.div('segmentBlock', {
    legacy: segmentBlock,
    citrus2022: segmentBlockCitron,
});
export var SegmentPointer = citrusStyled.div('segmentPointer', {
    legacy: segmentPointer,
    citrus2022: segmentPointerCitron,
});
export var SegmentLabel = citrusStyled.div('segmentLabel', {
    legacy: segmentLabel,
    citrus2022: segmentLabelCitron,
});
export var SegmentLegendWrapper = citrusStyled.div('segmentLegendWrapper', {
    legacy: segmentLegendWrapper,
    citrus2022: segmentLegendWrapperCitron,
});
export var SegmentLegendTitle = citrusStyled.div('segmentLegendTitle', {
    legacy: segmentLegendTitle,
    citrus2022: segmentLegendTitleCitron,
});
export var SegmentLegendLabel = citrusStyled.div('segmentLegendLabel', {
    legacy: segmentLegendLabel,
    citrus2022: segmentLegendLabelCitron,
});
export var TrendLargeWrapper = citrusStyled.div('trendLargeWrapper', {
    legacy: trendLargeWrapper,
    citrus2022: trendLargeWrapperCitron,
});
export var TrendSmallWrapper = citrusStyled.div('trendSmallWrapper', {
    legacy: trendSmallWrapper,
    citrus2022: trendSmallWrapperCitron,
});
export var TrendLarge = citrusStyled.span('trendLarge', { legacy: trendLarge, citrus2022: trendLargeCitron });
export var TrendSmall = citrusStyled.span('trendSmall', { legacy: trendSmall, citrus2022: trendSmallCitron });
export var TrendHeaderWrapper = citrusStyled.span('trendHeaderWrapper', {
    legacy: trendHeaderWrapper,
    citrus2022: trendHeaderWrapperCitron,
});
export var Styled = {
    BarWrapper: BarWrapper,
    BarWrapperBackground: BarWrapperBackground,
    DataBar: DataBar,
    Footnote: Footnote,
    Header: Header,
    HeaderLarge: HeaderLarge,
    HeaderExtraLarge: HeaderExtraLarge,
    HeaderInline: HeaderInline,
    HeaderInlineLarge: HeaderInlineLarge,
    Inline: Inline,
    ProgressBar: ProgressBar,
    Step: Step,
    StepProgressBar: StepProgressBar,
    SegmentBarWrapper: SegmentBarWrapper,
    SegmentWrapper: SegmentWrapper,
    SegmentBlock: SegmentBlock,
    SegmentPointer: SegmentPointer,
    SegmentLabel: SegmentLabel,
    SegmentLegendWrapper: SegmentLegendWrapper,
    SegmentLegendTitle: SegmentLegendTitle,
    SegmentLegendLabel: SegmentLegendLabel,
    TrendLargeWrapper: TrendLargeWrapper,
    TrendSmallWrapper: TrendSmallWrapper,
    TrendLarge: TrendLarge,
    TrendSmall: TrendSmall,
    TrendHeaderWrapper: TrendHeaderWrapper,
};
